import Listitem from "./Listitem"

function Todolist(props){
    var mylist = props.mylist
    var setmylist = props.setmylist
    return (
        <div className="bg-[#BDB0E8] p-2 border rounded-md flex-grow">
            <h1 className="text-2xl font-medium">Today's Activity</h1>
            {mylist.length===0?<p>You haven't added anything yet</p>:""}
            <ol className="px-5">
                {
                    mylist.map(function(items){
                    return <Listitem id={items.id} activity={items.activity} mylist={mylist} setmylist={setmylist}/>
                    
                })
                }
                
            </ol>

        </div>
    )
}
export default Todolist